import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PAYMENT_TERM } from "./apiRoutes";

interface UseGetProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getPaymentTermDropdown = async (communityId: string) =>
  await axiosAuth.get(`${PAYMENT_TERM}/community/${communityId}/dropdown`);

const useGetPaymentTermDropdown = ({
  communityId,
  queryParams,
}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["payment-term-dropdown", communityId],
    queryFn: () => getPaymentTermDropdown(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
  });
};

export default useGetPaymentTermDropdown;
